module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_piolink.ce429fc182f36445c607499c1f355c96.png";